export const zh_HK = {
    LEFT: '左移动的前一天。',
    RIGHT: '权利：移至第二天。 ',
    DOWN: '下：移动到下一行。 ',
    UP: '：移至上一个行。 ',
    PGUP: '上一页：移至前一个月。 ',
    PGDOWN: 'PgDown：移到下个月。 ',
    HOME: 'Home：移至前一年。 ',
    END: '端：移到下一年。',
    ESC: 'Esc/Today/关闭的日历。 ',
    TITLE: '键盘说明'
};
